
if (!customElements.get('c2f-buybar')) {
 customElements.define('c2f-buybar',class extends HTMLElement {
  connectedCallback(){
   if(this.abort)return;
   this.main=document.querySelector('c2f-product')||document.querySelector('[id^="MainProduct-"]');
   if(!this.main)return;
   this.abort=new AbortController();const opts={signal:this.abort.signal};
   this.config=JSON.parse(this.querySelector('[data-buybar-config]').textContent);
   this.button=this.querySelector('[data-buybar-submit]');
   this.source=()=>this.main.querySelector('.c2f-purchase [name="add"]')||this.main.querySelector('product-form [name="add"].button--static')||this.main.querySelector('product-form [name="add"]');
   if(!this.source())return;
   this.form=()=>this.main.querySelector('[data-c2f-form]')||this.main.querySelector('product-form form');
   this.money=cents=>new Intl.NumberFormat(this.config.locale||'fr',{style:'currency',currency:this.config.currency}).format(cents/100);
   this.queue=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.sync());};
   this.main.addEventListener('change',this.queue,opts);this.main.addEventListener('input',this.queue,opts);
   this.main.addEventListener('c2f:variant-change',event=>{this.premium=event.detail;this.sync();},opts);
   this.mutations=new MutationObserver(this.queue);this.mutations.observe(this.main,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','aria-busy','value','class','hidden']});
   this.intersection=new IntersectionObserver(()=>this.visibility(),{threshold:0});this.intersection.observe(this.source());
   addEventListener('scroll',()=>this.visibility(),{...opts,passive:true});addEventListener('resize',()=>this.visibility(),opts);
   this.querySelector('.c2f-buybar__edit').addEventListener('click',()=>{
    const target=this.main.querySelector('.c2f-variants,.c2f-historical-picker,variant-selects,variant-radios')||this.form();
    target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
    target.querySelector('input:not([type=hidden]),select,button')?.focus({preventScroll:true});
   },opts);
   this.button.addEventListener('click',()=>{
    const source=this.source();
    if(!source||source.disabled||source.getAttribute('aria-disabled')==='true')return;
    const form=this.form();if(!form.reportValidity()){form.scrollIntoView({behavior:'smooth',block:'center'});return;}
    this.pendingPurchase=true;source.click();this.sync();
   },opts);
   document.body.classList.add('c2f-buybar-ready');this.hidden=false;this.sync();this.visibility();
  }
  sync(){
   const form=this.form(),source=this.source();if(!form||!source)return;
   const id=form.elements.id?.value;
   const variant=this.config.variants.find(v=>String(v.id)===String(id));
   const quantity=Math.max(1,parseInt(this.main.querySelector('[name="quantity"]')?.value,10)||1);
   const matchingPremium=this.premium&&String(this.premium.variant.id)===String(id)?this.premium:null;
   let total=variant?variant.price*quantity:0;
   if(this.main.matches('c2f-product')){
    const extra=[...form.querySelectorAll('[data-c2f-extra]:checked')].reduce((sum,x)=>sum+Number(x.dataset.price||0),0);
    total=((variant?.price||0)+extra)*quantity;
    if(matchingPremium)total=matchingPremium.unitTotal*Math.min(99,quantity);
   }
   if(variant){
    this.querySelector('[data-buybar-price]').textContent=this.money(total);
    const title=matchingPremium?.variant.label||variant.title;
    this.querySelector('[data-buybar-variant]').textContent=(quantity>1?quantity+' × ':'')+(title==='Default Title'?this.config.labels.selection:title);
    const image=this.querySelector('.c2f-buybar__image');if(image&&variant.image&&image.getAttribute('src')!==variant.image){image.src=variant.image;image.removeAttribute('srcset');}
   }
   const busy=source.getAttribute('aria-busy')==='true'||source.classList.contains('loading');
   this.button.disabled=source.disabled||source.getAttribute('aria-disabled')==='true'||!variant?.available;
   this.button.setAttribute('aria-busy',String(busy));this.querySelector('.c2f-buybar__spinner').hidden=!busy;
   this.querySelector('[data-buybar-label]').textContent=busy?this.config.labels.adding:(!variant?.available?this.config.labels.soldOut:this.config.labels.add);
   if(this.pendingPurchase&&!busy){
    const error=this.main.querySelector('[data-c2f-message]:not([hidden]):not([data-success]),.product-form__error-message-wrapper:not([hidden])');
    if(error?.textContent.trim()){this.pendingPurchase=false;error.scrollIntoView({behavior:'smooth',block:'center'});}
   }
   this.visibility();
  }
  visibility(){
   const source=this.source();if(!source)return;
   const sourceRect=source.getBoundingClientRect();
   const title=this.main.querySelector('h1');
   const mobile=matchMedia('(max-width:749px)').matches;
   const viewportHeight=window.visualViewport?.height||innerHeight;
   const sourceOnScreen=sourceRect.bottom>0&&sourceRect.top<viewportHeight;
   const visible=sourceRect.bottom<0||(mobile&&title?.getBoundingClientRect().bottom<0&&!sourceOnScreen);
   this.dataset.visible=String(visible);this.inert=!visible;
   document.body.classList.toggle('c2f-buybar-shown',visible);
   const preview=document.getElementById('PBarNextFrame');const rect=preview?.getBoundingClientRect();
   const height=rect&&rect.height<150&&rect.bottom>=innerHeight-2?rect.height:0;
   const val=height+'px';if(document.body.style.getPropertyValue('--c2f-preview-bottom')!==val)document.body.style.setProperty('--c2f-preview-bottom',val);
  }
  disconnectedCallback(){this.abort?.abort();this.abort=null;this.mutations?.disconnect();this.intersection?.disconnect();cancelAnimationFrame(this.frame);document.body.classList.remove('c2f-buybar-ready','c2f-buybar-shown');}
 });
}

